export const SET_USER_IS_ADMIN = "SET_USER_IS_ADMIN";
export const SET_ADMIN_DATA = "SET_ADMIN_DATA";

// Partial update actions
export const SET_ADMIN_USERS = "SET_ADMIN_USERS";
export const SET_ADMIN_TASKS = "SET_ADMIN_TASKS";
export const SET_ADMIN_SESSIONS = "SET_ADMIN_SESSIONS";
export const SET_ADMIN_STATS = "SET_ADMIN_STATS";
export const SET_ADMIN_FEEDBACK = "SET_ADMIN_FEEDBACK";
export const SET_ADMIN_CONVERSATIONS = "SET_ADMIN_CONVERSATIONS";

// Loading state actions
export const SET_ADMIN_LOADING = "SET_ADMIN_LOADING";
